import axios from 'axios';

// ACTION
export const CARD = {
    GET_MAIN_DATA: 'GET_MAIN_DATA',
    SET_PDF: 'SET_PDF',

    SET_STUDENT_STATUS: 'SET_STUDENT_STATUS',
    SET_DAY_STATUS: 'SET_DAY_STATUS',
    SET_FAMILY_STATUS: 'SET_FAMILY_STATUS',
    SET_NEXT_STEP: 'SET_NEXT_STEP',
    SET_DISABLED_SETTING_SCREEN: 'SET_DISABLED_SETTING_SCREEN',
    CHANGE_DURATION: 'CHANGE_DURATION',
    CHANGE_FREEZING: 'CHANGE_FREEZING',
    SET_ACCESS_CLUBS_STR: 'SET_ACCESS_CLUBS_STR',
    SET_RESULT_CARD: 'SET_RESULT_CARD',
    SET_PROLONGATION: 'SET_PROLONGATION',
    RESET_STEP: 'RESET_STEP',
    SET_ONLINE: 'SET_ONLINE',
    SET_CHECKED_CLUB: 'SET_CHECKED_CLUB',
    SET_CUSTOM_STATUS: 'SET_CUSTOM_STATUS',
    SET_CUSTOMER_DATA: 'SET_CUSTOMER_DATA',
    SET_SECOND_CUSTOMER_DATA: 'SET_SECOND_CUSTOMER_DATA',
    SET_PROMOCODE: 'SET_PROMOCODE',
    SWITCH_MILLENIUM_CLUB: 'SWITCH_MILLENIUM_CLUB',
    SWITCH_INSTALLMENT_DISCOUNT: 'SWITCH_INSTALLMENT_DISCOUNT',
    SET_GAMELEAD_DISCOUNT: 'SET_GAMELEAD_DISCOUNT',
    SET_GAMELEAD_PRESENT: 'SET_GAMELEAD_PRESENT',
    SET_WIDGET_DISCOUNT: 'SET_WIDGET_DISCOUNT',
    SET_WIDGET_PRESENT: 'SET_WIDGET_PRESENT',
    SET_PHONE_CHECKED: 'SET_PHONE_CHECKED',
    SET_ORDER_CODE: 'SET_ORDER_CODE',
    SET_FITBON_DISCOUNT_PERCENT: 'SET_FITBON_DISCOUNT_PERCENT',
    SET_FITBON_DISCOUNT: 'SET_FITBON_DISCOUNT',
};

// ACTION CREATORS
export function getMainData() {
    return async (dispatch) => {
        axios({
            method: 'get',
            url: `${process.env.REACT_APP_API_SITE}/tariffs/${process.env.REACT_APP_TEST_DATA == 1 ? 'test-' : ''}data`,
            headers: {
                'Accept': '*/*',
                'Content-Type': 'application/json',
            },
        })
        .then(function (response) {
            if (response.status === 200 || response.status === 201) {

                dispatch({
                    type: CARD.GET_MAIN_DATA,
                    mainData: response.data.data
                })
            }
        })
        .catch(function (error) {
            console.log(error.response);
        });
    }
}

export function setStudentStatus(status) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_STUDENT_STATUS,
            status
        })
    }
}

export function setFamilyStatus(status) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_FAMILY_STATUS,
            status
        })
    }
}

export function setDayStatus(status) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_DAY_STATUS,
            status
        })
    }
}

export function setNextStep(step) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_NEXT_STEP,
            step
        })
    }
}

export function setDisabledSettingScreen(step) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_DISABLED_SETTING_SCREEN,
            step
        })
    }
}

export function changeDuration(countMonth) {
    return async (dispatch) => {
        dispatch({
            type: CARD.CHANGE_DURATION,
            countMonth
        })
    }
}

export function changeFreezing(countMonth) {
    return async (dispatch) => {
        dispatch({
            type: CARD.CHANGE_FREEZING,
            countMonth
        })
    }
}

export function setProlongation(prolongation, prolongationDiscount) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_PROLONGATION,
            prolongation,
            prolongationDiscount
        })
    }
}

export function setResultCard(card) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_RESULT_CARD,
            card
        })
    }
}

export function setCustomerData(data) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_CUSTOMER_DATA,
            data
        })
    }
}

export function setSecondCustomerData(data) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_SECOND_CUSTOMER_DATA,
            data
        })
    }
}

export function resetStep(step) {
    return async (dispatch) => {
        dispatch({
            type: CARD.RESET_STEP,
            step
        })
    }
}

export function setCheckedClub(flag) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_CHECKED_CLUB,
            clubIsChecked: flag
        })
    }
}

export function setCustomStatus(flag, shouldRestore = false) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_CUSTOM_STATUS,
            custom: flag,
            restore: shouldRestore
        })
    }
}

export function setPromocode(data) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_PROMOCODE,
            data
        })
    }
}

export function switchMilleniumClub(data) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SWITCH_MILLENIUM_CLUB,
            data
        })
    }
}

export function switchInstallmentDiscount(data) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SWITCH_INSTALLMENT_DISCOUNT,
            data
        })
    }
}

export function setGameleadDiscount(discount) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_GAMELEAD_DISCOUNT,
            discount
        })
    }
}

export function setGameleadPresent(present) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_GAMELEAD_PRESENT,
            present
        })
    }
}

export function setWidgetDiscount(discount) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_WIDGET_DISCOUNT,
            discount
        })
    }
}

export function setWidgetPresent(present) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_WIDGET_PRESENT,
            present
        })
    }
}

export function setPhoneChecked(data) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_PHONE_CHECKED,
            data
        })
    }
}

export function setOrderCode(code) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_ORDER_CODE,
            code
        })
    }
}

export function setFitbonDiscountPercent(discount) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_FITBON_DISCOUNT_PERCENT,
            discount
        })
    }
}

export function setFitbonDiscount(discount) {
    return async (dispatch) => {
        dispatch({
            type: CARD.SET_FITBON_DISCOUNT,
            discount
        })
    }
}